export default ["LeBron 14****5069 组团成功获得5折券",
"微笑的侧脸 15****3861 组团成功获得5折券",
"巴黎夜雨 15****2088 组团成功获得5折券",
"历日旷久 15****2224 组团成功获得5折券",
"租房找潘潘 18****9430 组团成功获得5折券",
"郑少敏 14****9155 组团成功获得5折券",
"小太阳 14****9941 组团成功获得5折券",
"A13143118398 15****2637 组团成功获得5折券",
"le 18****9483 组团成功获得5折券",
"烛影斜 14****5409 组团成功获得5折券",
"43° 15****3208 组团成功获得5折券",
"甜甜圈 18****3588 组团成功获得5折券",
"AA 17****1751 组团成功获得5折券",
"心存善念 14****5359 组团成功获得5折券",
"平安 17****1675 组团成功获得5折券",
"V客 17****7800 组团成功获得5折券",
"Eve 18****3641 组团成功获得5折券",
"Tina 婷 17****3741 组团成功获得5折券",
"肉饼葵 15****9357 组团成功获得5折券",
"王颖 14****7224 组团成功获得5折券",
"大笑 18****8042 组团成功获得5折券",
"木子 18****2850 组团成功获得5折券",
"Amy老师 13****5289 组团成功获得5折券",
"安居小安 17****9464 组团成功获得5折券",
"李靖博 17****2506 组团成功获得5折券",
"琴台 14****4526 组团成功获得5折券",
"尹光雄 14****6531 组团成功获得5折券",
"心想事成 17****1853 组团成功获得5折券",
"泊娘子 15****9199 组团成功获得5折券",
"布依女孩 14****9555 组团成功获得5折券	",
"蔡国青 14****9446 组团成功获得5折券",
"草莓张 13****1250 组团成功获得5折券",
"feock 15****4990 组团成功获得5折券",
"李金丹 15****1447 组团成功获得5折券",
"Ayumi 13****7977 组团成功获得5折券",
"FINI 泽宁 14****9441 组团成功获得5折券",
"Simon廖 15****4018 组团成功获得5折券",
"老邢 15****5213 组团成功获得5折券",
"坤益通 13****5774 组团成功获得5折券",
"HEINARE 14****1856 组团成功获得5折券",
"Vivi 18****7891 组团成功获得5折券",
"况坚 14****5414 组团成功获得5折券",
"陈建 17****6695 组团成功获得5折券",
"Filippo 15****9857 组团成功获得5折券",
"刘亚梅 15****6478 组团成功获得5折券",
"康康 18****0038 组团成功获得5折券",
"广佛项目组 14****6256 组团成功获得5折券",
"凯子 15****0011 组团成功获得5折券",
"积分入户何梦 14****7995 组团成功获得5折券",
"Sergey 14****4633 组团成功获得5折券",
"Ciel 14****2689 组团成功获得5折券",
"蒋敏 14****7062 组团成功获得5折券",
"Iven 饶寒 15****4649 组团成功获得5折券",
"刘琦 JO 18****8227 组团成功获得5折券",
"林生 14****4897 组团成功获得5折券",
"花开遍野 18****8530 组团成功获得5折券",
"April 15****9375 组团成功获得5折券",
"郭洋 13****7414 组团成功获得5折券",
"Carmen 17****9016 组团成功获得5折券",
"龙行天下 14****2656 组团成功获得5折券",
"蜜语 17****8912 组团成功获得5折券",
"菜菜 14****4487 组团成功获得5折券",
"Hello world 13****2777 组团成功获得5折券",
"黄延延 13****9061 组团成功获得5折券",
"何伊萍 15****5343 组团成功获得5折券",
"花店萌萌 15****3115 组团成功获得5折券",];